export const SET_USUARIO = 'SET_USUARIO';
export const LOGOUT = 'LOGOUT';
export const MENSAJE = 'MENSAJE';
